import { createContext } from "react";
import type { Player, Players, ToneAudioBuffer, BaseContext } from "tone";

export type AddPlayerOptions = {
  name:string;
  url: string | ToneAudioBuffer | AudioBuffer;
  callback?: () => void;
}

export type AudioProviderContextType = {
  audioCtxStarted: boolean,
  players: Players,
  addPlayer: (options:AddPlayerOptions) => Player,
  getContext: () => BaseContext
  [key:string]: any
};

export const ReactAudioContext = createContext<AudioProviderContextType | null>(null);
